import { useQueryClient } from "@tanstack/react-query";
import { SPECIES_MASTER } from "../../../../enums/QueryKeys";

export default function useSingleSpecies(id) {
  const queryClient = useQueryClient();
  const allSpecies = queryClient.getQueryData([SPECIES_MASTER]);
  const species = allSpecies?.find((item) => item.id === id);

  return {species};
}
